import Auth from './auth';

export default Auth;
export { startAuth, login, checkSession, logout } from './auth';
